import { ThemeUIStyleObject } from 'theme-ui';
import { CarrotTheme } from '..';

const baseStyles = {
    ul: {
        margin: (theme: CarrotTheme) => `${theme.space.small} 0px ${theme.space.small} -24px`,
        paddingLeft: '40px',
    },
    li: {
        marginBottom: (theme: CarrotTheme) => theme.space.small,
        '::before': {
            content: '"\\2022"',
            color: (theme: CarrotTheme) => theme.colors.carrotOrange,
            display: 'inline-block',
            width: '1em',
            marginLeft: '-1em',
        },
        ':last-child': {
            marginBottom: 0,
        },
    },
};

const lists: Record<string, ThemeUIStyleObject> = {
    ...baseStyles,
};
export default lists;
